/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_TitleInputs */

const en_tags_manager_title = /** @type {(inputs: Tags_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Tag Manager`)
};

const fr_tags_manager_title = /** @type {(inputs: Tags_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionnaire de tags personnalises`)
};

const de_tags_manager_title = /** @type {(inputs: Tags_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerdefinierter Tag-Manager`)
};

const it_tags_manager_title = /** @type {(inputs: Tags_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestore tag personalizzato`)
};

const ru_tags_manager_title = /** @type {(inputs: Tags_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Менеджер пользовательских тегов`)
};

const es_tags_manager_title = /** @type {(inputs: Tags_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrador de etiquetas personalizado`)
};

const zh_cn2_tags_manager_title = /** @type {(inputs: Tags_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自定义标签管理器`)
};

const ja_tags_manager_title = /** @type {(inputs: Tags_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カスタムタグマネージャー`)
};

const hi_tags_manager_title = /** @type {(inputs: Tags_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कस्टम टैग मैनेजर`)
};

const pt_pt2_tags_manager_title = /** @type {(inputs: Tags_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerenciador de tags personalizadas`)
};

/**
* | output |
* | --- |
* | "Custom Tag Manager" |
*
* @param {Tags_Manager_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_title = /** @type {((inputs?: Tags_Manager_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_title(inputs)
	if (locale === "de") return de_tags_manager_title(inputs)
	if (locale === "it") return it_tags_manager_title(inputs)
	if (locale === "ru") return ru_tags_manager_title(inputs)
	if (locale === "es") return es_tags_manager_title(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_title(inputs)
	if (locale === "ja") return ja_tags_manager_title(inputs)
	if (locale === "hi") return hi_tags_manager_title(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_title(inputs)
	return en_tags_manager_title(inputs)
});